import { getCookie } from './helpers/cookieHelper';

const getDefaultHeaders = () => {
    return {/* 'X-XSRF-TOKEN': getCookie("AvePDF_AntiForgery") */};
}

export { getDefaultHeaders };